import { InvokeAction as InvokeActionComponent } from "./InvokeAction";
import { loader, shouldRevalidate } from "./loader";

export const InvokeAction = {
  Component: InvokeActionComponent,
  loader,
  shouldRevalidate,
};
